import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store, select } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectUtilsState } from 'app/store/app.states';



@Component({
  selector: 'app-dialog-cfdi-realcionados',
  templateUrl: './dialog-cfdi-realcionados.component.html',
  styleUrls: ['./dialog-cfdi-realcionados.component.scss'],
  providers: [CoalService]
})
export class DialogCfdiRelacionadosComponent implements OnInit {

  nombreReporte: string = 'CFDI-Relacionados';
  objetoGridConfiguration: any;
  objetosSelected: any;
  datosevent: any;
  verGrid: boolean = false;
  descargarExcel: boolean = true;
  empresaData: any;

  cfdis: any[] = [];
  cliente: any;
  relacion: any;

  cfdisCheck: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogCfdiRelacionadosComponent>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private coalService: CoalService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.cliente = data?.cliente || {};
    this.cfdis = data?.data || [];
    this.relacion = data?.relacion || {};
    this.ObjectGrid();

  }

  async ngOnInit(): Promise<void> {

    this.empresaData = await this.getData();
    console.log("🚀 ~ file: dialog-new-cfdi.component.ts:98 ~ DialogNewCfdiComponent ~ ngOnInit ~ this.empresaData:", this.empresaData)

    //Se values
    this.verGrid = true;
    this.objetoGridConfiguration.Data = this.cfdis.length > 0 ? this.cfdis : [];
  }

  public getData(): Promise<any> {
    return new Promise<any>(resolve => {
      this.store.pipe(select(selectUtilsState)).subscribe((info: any) => {
        let empresa = info?.empresaSeleccionada || null;
        resolve(empresa);
      });

    });

  }

  ObjectGrid() {
    let that = this;
    this.objetoGridConfiguration = {
      GridOptions: {
        paginacion: 20,
        pageSize: ['40', '60', '80', '100'],
      },
      ExportExcel: { enabled: true, fileName: 'Historico' },
      ColumnHiding: { hide: true },
      Checkbox: { checkboxmode: 'multiple' },
      Editing: { allowupdate: true, mode: 'cell' },
      Columnchooser: { columnchooser: true },
      SearchPanel: {
        visible: true,
        width: 200,
        placeholder: 'Buscar...',
        filterRow: true,
      },
      Scroll: { mode: 'infinite' },
      Color: null,
      Detail: { detail: true },
      ToolbarDetail: null,
      ToolBox: [],
      Columns: [],
      Data: [],
      Columns1: [1],
      Data1: [],
      datosMessage(evento) {
        that.objetosSelected = evento.data;
      },
    };
    this.DataColumnsGrid();
  }

  DataColumnsGrid() {
    let columnsMulti = [];
    columnsMulti.push({
      caption: 'Tipo comprobante',
      dataField: 'comprobante',
      allowEditing: false,
      fixed: true,
    });
    columnsMulti.push({
      caption: 'Serie',
      dataField: 'serie',
      allowEditing: false,
    });
    columnsMulti.push({
      caption: 'Folio',
      dataField: 'folio',
      allowEditing: false,
    });
    columnsMulti.push({
      caption: 'Importe',
      dataField: 'total',
      allowEditing: false,
    });
    columnsMulti.push({
      caption: 'Fecha emisión',
      dataField: 'fecha',
      allowEditing: false,
    });
    columnsMulti.push({
      caption: 'UUID',
      dataField: 'uuid',
      allowEditing: false,
    });
    this.objetoGridConfiguration.Columns = columnsMulti;
  }

  addRelacion(status) {

    this.dialogRef.close({
      success: status,
      data:this.cfdisCheck 
    });

  }
  receiveMessage(value) {
    //console.log("🚀 ~ DialogCfdiRelacionadosComponent ~ receiveMessage ~ value:", value)

  }
  datosMessage(row:any) {
    //console.log("🚀 ~ DialogCfdiRelacionadosComponent ~ datosMessage ~ row:", row)
    this.cfdisCheck = row?.data || [];
  }
   
  Actualizar(value) {
    //console.log("🚀 ~ DialogCfdiRelacionadosComponent ~ Actualizar ~ value:", value)
  }
  modificar(value) {
    //console.log("🚀 ~ DialogCfdiRelacionadosComponent ~ modificar ~ value:", value)
  }
  eliminar(value) {
    //console.log("🚀 ~ DialogCfdiRelacionadosComponent ~ eliminar ~ value:", value)
  }

  close(status) {
    this.dialogRef.close({
      success: status,
      data:[]
    });
  }

}
